// Official SIDA wordmark from the Brand Book.
// Auto-swaps between cyan (light mode) and white (dark mode) variants.
// Implemented as two stacked <img> tags toggled via Tailwind's class-based dark mode
// so it adapts instantly to theme changes without JS.
export const SidaWordmark = ({ className }: { className?: string }) => (
  <span className={`inline-block ${className ?? ""}`}>
    <img
      src="/sida-logo-blue.webp"
      alt="SIDA"
      width={800}
      height={213}
      draggable={false}
      loading="lazy"
      decoding="async"
      className="block dark:hidden h-full w-auto select-none"
    />
    <img
      src="/sida-logo-cyan.webp"
      alt=""
      aria-hidden="true"
      width={800}
      height={213}
      draggable={false}
      loading="lazy"
      decoding="async"
      className="hidden dark:block h-full w-auto select-none"
    />
  </span>
);
